import { Character } from "../state/character";
import styles from "../styles/share.module.css";
import pumpLogo from "../assets/PumpLogo.webp";
import { useGame } from "../game/engine/useGameEngine";
import { PUMP_LINK } from "../constants/social";

export default function ShareModal({ winner }: { winner: Character }) {
  const { replay } = useGame();

  // &url=${encodeURIComponent(winner.winningImg || window.location.href)}

  const handleShare = () => {
    // Open Twitter share window with dataURL
    const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      `I just won the $TKO World Championship with ${winner.name}!\n\nBuy $TKO NOW\n${window.location.href}\n@DeptOfGovBoxing\n\n`
    )}`;
    window.open(twitterShareUrl, "_blank");
  };

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div className={styles.header}>TRUMP WINS</div>

        <button className={`button ${styles.replay}`} onClick={replay}>
          Replay
        </button>
      </div>
    </div>
  );
}
